(function(angular){
	'use strict';

	angular.module('unemploymentComparisonChartModule', [
		'highChartsModule'
	]);
})(window.angular);